import styled from '@emotion/styled'
import React from 'react'

import Tick, { TickWrapper } from './Tick'
import { formControlReset } from 'styles/reset'

const Wrapper = styled.div`
	position: relative;
	width: 100%;
`

const Pill = styled.label`
	display: flex;
	position: relative;
	align-items: center;
	background-color: ${({ theme }) => theme.colors.light.surfaceVariant};
	border-radius: ${({ theme }) => theme.borderRadiuses.lg};
	cursor: pointer;
`

const HiddenInput = styled.input`
	${formControlReset};
	position: absolute;
	top: 0;
	left: 0;

	& + label {
		border: 2px solid transparent;

		${TickWrapper} {
			display: none;
		}
	}

	&:checked + label {
		border: 2px solid ${({ theme }) => theme.colors.light.surfaceInteractive};

		${TickWrapper} {
			display: flex;
		}
	}

	&:focus-visible + label {
		outline: 1px solid ${({ theme }) => theme.colors.light.accent};
		outline-offset: 2px;
	}
`

type Props = JSX.IntrinsicElements['input']

const PillRadio = React.forwardRef<HTMLInputElement, Props>(({ children, ...inputProps }: Props, ref) => {
	const id = React.useId()
	return (
		<Wrapper>
			<HiddenInput id={id} type="radio" {...inputProps} ref={ref} />
			<Pill htmlFor={id}>
				<Tick />
				{children}
			</Pill>
		</Wrapper>
	)
})

PillRadio.displayName = 'PillRadio'

export default PillRadio
